export default __webpack_public_path__ + "static/media/spooky_hill_xl3.1971d3bb.png";